import Phaser from 'phaser';
import { LEVELS } from '../config/levels';
import { fruitDisplayName } from '../render/fruits';
import { GameState } from '../state/GameState';
import { SaveStore } from '../state/SaveStore';
import type { ThemeKey } from '../types';

function levelTitleFor(theme: ThemeKey): string {
  if (theme === 'river') return 'OCEAN';
  return theme.toUpperCase();
}

export class LevelIntroScene extends Phaser.Scene {
  private level = 1;

  constructor() {
    super('LevelIntroScene');
  }

  init(data: { level?: number }): void {
    this.level = data.level ?? GameState.getLevel(this.registry);
  }

  create(): void {
    GameState.setLevel(this.registry, this.level);
    SaveStore.save({
      character: GameState.getCharacter(this.registry),
      animal: GameState.getAnimal(this.registry),
      level: this.level,
    });

    const W = this.scale.width;
    const H = this.scale.height;
    const cfg = LEVELS[this.level];

    this.add.rectangle(0, 0, W, H, 0x1d2434).setOrigin(0, 0);
    this.add
      .text(W / 2, H / 2 - 80, `Level ${this.level}`, {
        fontFamily: 'sans-serif',
        fontSize: '64px',
        color: '#ffd9a0',
      })
      .setOrigin(0.5);
    this.add
      .text(W / 2, H / 2 - 10, levelTitleFor(cfg.theme), {
        fontFamily: 'sans-serif',
        fontSize: '36px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
    this.add
      .text(W / 2, H / 2 + 50, `Collect ${cfg.target} ${fruitDisplayName(cfg.fruit).toLowerCase()}`, {
        fontFamily: 'sans-serif',
        fontSize: '24px',
        color: '#bcd0e0',
      })
      .setOrigin(0.5);
    if (cfg.hasBossAtEnd) {
      this.add
        .text(W / 2, H / 2 + 90, '⚔  Boss waits at the end!', {
          fontFamily: 'sans-serif',
          fontSize: '22px',
          color: '#f2c14e',
        })
        .setOrigin(0.5);
    }

    this.time.delayedCall(1500, () => {
      this.scene.start('GameScene', { level: this.level });
    });
  }
}
